export const AUTH_ENDPOINTS = {
  LOGIN: "/auth/login",
  SESSION_TOKEN: "/auth/session-token",
  FORGOT_PASSWORD: "/auth/forgot-password",
  VERIFY_USER: (digest) => `/auth/verify-user/${digest}`,
  REFRESH_TOKEN: "/auth/renewtoken",
};

export const ACCOUNT_ENDPOINTS = {
  LIST: "/accounts",
  MODULES: "/accounts/modules",
  DASHBOARD: "/accounts/dashboard",

  UPLOAD_FILE: "/accounts/upload-file",
  UPLOADED_FILES: "/accounts/uploaded-files",

  LICENSE_SUMMARY: "/accounts/license-summary",
  LICENSE_REDEMPTIONS: "/accounts/license-redemptions",
  GENERATE_LICENSE: "/accounts/generate-license",
  REGENERATE_LICENSE: (id) => `/accounts/redemptions/${id}/retry`,

  UPDATE_ACCOUNT: "/accounts",
  ACCOUNT_AUDIT_LOG: `/audit-log`,
};

export const WIDGET_ENDPOINTS = {
  GET_WIDGETS: (dashboardId) => `/widgets/${dashboardId}`,
  GET_WIDGET_TYPES: `/widgets/types`,
  DELETE_WIDGET: (widgetId) => `/widgets/${widgetId}`,
  ADD_WIDGET: `/widgets`,
  UPDATE_WIDGET: (widgetId) => `/widgets/${widgetId}`,
  UPDATE_WIDGET_POSITION: `/widgets`,
};

export const USER_ENDPOINTS = {
  USERS: `/users`,
  USER_BY_ID: (id) => `/users/${id}`,
  SECURITY_GROUPS: `/security-groups`,
};

export const DEVICE_ENDPOINTS = {
  SITES: "/sites",
  UPDATE_SITE: (id) => `/sites/${id}`,
  LANES: "/lanes",
  UPDATE_LANE: (id) => `/lanes/${id}`,

  DEVICES: `/devices`,
  DEVICE_BY_ID: (id) => `/devices/${id}`,
  DEVICE_TYPES: `/devices/types`,
  DEVICE_EXPORT: `/devices/export/pdf`,
  DEVICE_UNIQUE_LOCATIONS: (ids) => `/devices/unique-locations?devices=${ids}`,

  // Device Locations
  DEVICE_LOCATIONS: (id) => `/devices/${id}/locations`,
  DEVICE_LOCATION_LIST: `/devices/location-list`,
  DEVICE_LOCATION_BY_ID: (locationId) => `/devices/locations/${locationId}`,

  EVENT_STATS: `/devicedata/eventstats`,
  EVENT_SUMMARY: `/devicedata/eventstats-summary`,
  READ_STATS: `/devicedata/readstats`,
  AUDIT_LOG: `/devicedata/auditlog`,
  CONFIG: `/devicedata/config`,
  LAST_REBOOT: `/devicedata/lastreboot`,
  OS_DATA: `/devicedata/os`,
  STATUS: `/devicedata/status`,
  STATUS_ID: `/devicedata/statusid`,
  FIRMWARE: `/devicedata/firmware`,
  HEARTBEAT: `/devicedata/heartbeat`,
  INFO: `/devicedata/info`,
};

export const ALERT_ENDPOINTS = {
  ALERTS: `/alerts`,
  ALERT_SUMMARY: `/alerts/summary`,

  CUSTOM_ALERTS: `/custom-alerts/alerts`,
  CUSTOM_ALERT_BY_ID: (id) => `/custom-alerts/alerts/${id}`,
  CUSTOM_ALERT_STATUS: (id) => `/custom-alerts/alerts/${id}/status`,

  ALERT_TEMPLATES: `/custom-alerts/templates`,
  ALERT_TEMPLATE_BY_ID: (id) => `/custom-alerts/templates/${id}`,
};

export const REPORT_ENDPOINTS = {
  SCHEDULED_REPORTS: `/reports/scheduled`,
  SCHEDULED_REPORT_BY_ID: (id) => `/reports/scheduled/${id}`,

  REPORT_TEMPLATES: `/reports/templates`,
  REPORT_TEMPLATE_BY_ID: (id) => `/reports/templates/${id}`,

  GENERATED_REPORTS: `/reports/generated-reports`,
  GENERATED_REPORT_BY_ID: (id) => `/reports/generated-reports/${id}`,

  GENERATE_REPORT: `/reports/generate`,
};

export const SUPPORT_ENDPOINTS = {
  ACCOUNTS: `/support/accounts`,
  ACCOUNT_BY_ID: (id) => `/support/accounts/${id}`,
  ACCOUNT_USERS: (id) => `/support/accounts/${id}/users`,

  IMPERSONATE: `/support/impersonate`,
  EXIT_IMPERSONATE: `/support/impersonate/exit`,
  REFRESH_IMPERSONATE: `/support/impersonate/refresh`,

  LICENSE_QUOTA: (id) => `/support/accounts/${id}/license-quota`,
  LICENSE_QUOTA_HISTORY: (id) =>
    `/support/accounts/${id}/license-quota-history`,
  SUPPORT_MODULES: (id) => `/support/accounts/${id}/modules`,
};

export const RELAY_ENDPOINTS = {
  // Device Relays
  RELAYS: `/device-relays`,
  RELAY_BY_ID: (id) => `/device-relays/${id}`,
  RELAY_UPDATE: (id, generateKey) =>
    `/device-relays/${id}?generate_key=${generateKey}`,
};

export const HAZMAT_ENDPOINTS = {
  // Hazmat
  HAZMAT_SUMMARY: `/hazmat/readings-summary`,
  HAZMAT_IMAGE: `/hazmat/image-link`,
  HAZMAT_EXPORT: `/hazmat/readings/export`,
};

export const DASHBOARD_ENDPOINTS = {
  // Dashboards
  DASHBOARDS: `/dashboards`,
  DASHBOARD_BY_ID: (id) => `/dashboards/${id}`,
  // Dynamic modules
  DYNAMIC_MODULE_READINGS: (moduleId) =>
    `/dynamic-modules/${moduleId}/readings`,
  // Settings
  APP_SETTINGS: `/settings/application`,
};

export const ESCREEN_ENDPOINTS = {
  E_SCREEN_DATA: () => `/screening-events/readings`,
  LOCATIONS_LIST: () => `/locations`,
  ESCREEN_IMAGE_URL: (imageId) => `/screening-events/images/${imageId}/url`,
  ESCREEN_EXPORT: () => `/screening-events/readings/pdf`,
};
